export enum EUserGroupRole {
  GroupMember = 'GROUP_MEMBER',
  GroupModerator = 'GROUP_MODERATOR',
  GroupAdmin = 'GROUP_ADMIN',
}
